/* Maps BCP-47 primary language subtags to EBU STL display names */
const languageMap = {
  af: null,
  sq: "Albanian",
  am: "Amharic",
  ar: "Arabic",
  hy: "Armenian",
  as: "Assamese",
  az: "Azerbaijani",
  eu: "Basque",
  be: "Bielorussian",
  bn: "Bengali",
  br: "Breton",
  bg: "Bulgarian",
  my: "Burmese",
  ca: "Catalan",
  zh: "Chinese",
  cmn: "Chinese",
  yue: "Chinese",
  cv: "Churash",
  hr: "Croatian",
  cs: "Czech",
  da: "Danish",
  fa: "Persian",
  prs: "Dari",
  nl: "Dutch",
  en: "English",
  eo: "Esperanto",
  et: "Estonian",
  fo: "Faroese",
  fi: "Finnish",
  fr: "French",
  fy: "Frisian",
  ff: "Fulani",
  gd: "Gaelic",
  gl: "Galician",
  ka: "Georgian",
  de: "German",
  el: "Greek",
  gu: "Gujurati",
  gn: "Gurani",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  hu: "Hungarian",
  is: "Icelandic",
  id: "Indonesian",
  jv: "Indonesian",
  su: "Indonesian",
  ga: "Irish",
  it: "Italian",
  ja: "Japanese",
  kn: "Kannada",
  kk: "Kazakh",
  km: "Khmer",
  ko: "Korean",
  lo: "Laotian",
  se: "Lappish",
  la: "Latin",
  lv: "Latvian",
  lt: "Lithuanian",
  lb: "Luxembourgian",
  mk: "Macedonian",
  mg: "Malagasay",
  ms: "Malaysian",
  mt: "Maltese",
  mr: "Marathi",
  mo: "Moldavian",
  nd: "Ndebele",
  ne: "Nepali",
  nb: "Norwegian",
  no: "Norwegian",
  nn: "Norwegian",
  oc: "Occitan",
  or: "Oriya",
  pap: "Papamiento",
  pl: "Polish",
  pt: "Portugese",
  pa: "Punjabi",
  ps: "Pushtu",
  qu: "Quechua",
  ro: "Romanian",
  rm: "Romansh",
  ru: "Russian",
  rue: "Ruthenian",
  sr: "Serbian",
  sh: "Serbo-croat",
  sn: "Shona",
  si: "Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  so: "Somali",
  es: "Spanish",
  srn: "Sranan Tongo",
  sw: "Swahili",
  sv: "Swedish",
  tg: "Tadzhik",
  ta: "Tamil",
  tt: "Tatar",
  te: "Telugu",
  th: "Thai",
  tr: "Turkish",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  vi: "Vietnamese",
  wa: "Wallon",
  cy: "Welsh",
  zu: "Zulu",
  fil: "Indonesian"
};
function bcp47ToEbuLanguageName(bcp47Tag) {
  if (!bcp47Tag || typeof bcp47Tag !== "string") {
    return null;
  }
  const normalized = bcp47Tag.trim();
  const primary = normalized.split("-")[0].toLowerCase();
  return languageMap[primary] || null;
}
export default {
  languageMap,
  bcp47ToEbuLanguageName
};